import { render, staticRenderFns } from "./QuizScore.vue?vue&type=template&id=2fd307d4&scoped=true"
import script from "./QuizScore.vue?vue&type=script&lang=ts"
export * from "./QuizScore.vue?vue&type=script&lang=ts"
import style0 from "./QuizScore.vue?vue&type=style&index=0&id=2fd307d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd307d4",
  null
  
)

export default component.exports